import {OSM, TileWMS, XYZ} from "ol/source";
import * as Cookies from 'js-cookie';
import TileLayer from "ol/layer/Tile";

export const mapTypes = {
    thunderforest: 'thunderforest',
    osm: 'osm',
    // hybrid: 'hybrid'
    google_hybrid: 'google_hybrid'
}

export const mapTypeLabels = {
    thunderforest: 'Thunderforest Landscape',
    osm: 'OSM',
    hybrid: 'Geoportal',
    google_hybrid: 'Google hybrid'
}

export const changeMapType = (mapLayer, type) => {
    if(!Object.keys(mapTypes).includes(type)) {
        return;
    }

    switch (type) {
        case mapTypes.thunderforest:
            mapLayer.setSource(new XYZ({url: 'https://tile.thunderforest.com/landscape/{z}/{x}/{y}.png?apikey=723ab88c4e634adca07e19a0d8f2633e'}));
            break;
        case 'hybrid':
            mapLayer.setSource(new TileWMS({
                url: 'https://mapy.geoportal.gov.pl/wss/service/PZGIK/ORTO/WMS/StandardResolution',
                params: {
                    'LAYERS': 'Raster',
                    'FORMAT': "image/png",
                    'srs': 'EPSG:2180'
                },
                serverType: 'geoserver'
            }))
            break;
        case 'google_hybrid':
            mapLayer.setSource(new OSM({
                attributions: [
                    'Map data ©' + new Date().getFullYear() + ' Google'
                ],
                url: "http://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}",
                maxZoom:21
            }))
            break;
        default:
            mapLayer.setSource(new OSM());
            Cookies.set('map-source', 'osm');
    }

    Cookies.set('map-source', type);
}

export const getSavedMapLayer = (select = null) => {
    let savedMap = Cookies.get('map-source') ?? 'osm';
    let layer = new TileLayer();
    changeMapType(layer, savedMap);

    if(select) {
        $(select).val(savedMap).trigger('change');
    }

    return layer;
}

export const fillMapTypeSelectWithTypes = () => {
    $('select[name="mapType"]').each(function () {
        for(let type in mapTypes) {
            let label = mapTypeLabels[type];
            $(this).append(`<option value="${type}">${label}</option>`);
        }
    })
}
